import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { AvatarSize } from './avatar.model'

@Component({
  selector: 'lin-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AvatarComponent {
  AvatarSize = AvatarSize

  @Input() source: string
  @Input() name: string
  @Input() surName: string
  @Input() size: AvatarSize = AvatarSize.sm

  get shortName(): string {
    return this.isShortName && this.name && this.surName ? `${this.name[0]}${this.surName[0]}` : ''
  }

  get isSource(): boolean {
    return !!this.source
  }

  get isShortName(): boolean {
    return !!this.name && !!this.surName && !this.isSource
  }

  get isDefault(): boolean {
    return !this.isSource && !this.isShortName
  }
}
